import { Cpu, Boxes, Timer, CloudCog, Sigma, TestTubeDiagonal, Globe, ArrowUpRight } from "lucide-react";
import { FadeUp } from "./Reveal";
import { SERVICES } from "@/lib/site-data";

const ICONS = { Cpu, Boxes, Timer, CloudCog, Sigma, TestTubeDiagonal, Globe };

const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-[#0a0a0c] py-28 md:py-40 border-t border-white/10"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <FadeUp className="max-w-2xl">
            <span className="overline">// Capabilities</span>
            <h2 className="mt-6 font-display font-700 text-4xl md:text-5xl lg:text-6xl tracking-tight text-white leading-[1.0]">
              What we design.
            </h2>
          </FadeUp>
          <FadeUp delay={0.1}>
            <p className="max-w-sm text-base leading-relaxed text-zinc-400">
              A single discipline spanning electronics, firmware, cloud and test —
              delivered as one coherent system.
            </p>
          </FadeUp>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <FadeUp key={s.id} delay={(i % 3) * 0.08} className={s.span}>
                <div
                  data-testid={`service-card-${s.id}`}
                  className="group relative h-full bg-white/[0.02] border border-white/10 p-7 md:p-8 hover:border-cyan-400/50 hover:bg-white/[0.04] transition-colors duration-400 clip-frame-sm"
                >
                  <div className="flex items-start justify-between">
                    <Icon className="h-7 w-7 text-cyan-400" strokeWidth={1.4} />
                    <ArrowUpRight className="h-5 w-5 text-zinc-600 group-hover:text-white group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all duration-300" />
                  </div>
                  <h3 className="mt-10 font-display font-600 text-xl md:text-2xl text-white tracking-tight">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-zinc-400 max-w-md">
                    {s.desc}
                  </p>
                  {s.example && (
                    <a
                      data-testid={`service-example-${s.id}`}
                      href={s.example.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                      className="mt-5 inline-flex items-center gap-2 font-mono text-[12px] uppercase tracking-[0.14em] text-cyan-400 border border-cyan-400/30 px-4 py-2 hover:bg-cyan-400 hover:text-black transition-colors duration-300"
                    >
                      Live example — {s.example.label}
                      <ArrowUpRight className="h-3.5 w-3.5" />
                    </a>
                  )}
                </div>
              </FadeUp>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
